import { render, staticRenderFns } from "./goodsSkuSelect.vue?vue&type=template&id=ad324788&"
import script from "./goodsSkuSelect.vue?vue&type=script&lang=js&"
export * from "./goodsSkuSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports